import type { ScreenModule } from "../../../app/screen-module";
import { CredentialSettingsPage } from "../SettingsPages";

export default {
	id: "end-user.credentials",
	path: "/app/settings/credentials",
	area: "end-user",
	navGroup: "自分の設定",
	label: "AI接続設定",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: CredentialSettingsPage,
} satisfies ScreenModule;
